import { render, staticRenderFns } from "./ShippingLogBLDetailBLFreightPop.vue?vue&type=template&id=9120bb2a"
import script from "./ShippingLogBLDetailBLFreightPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailBLFreightPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9120bb2a')) {
      api.createRecord('9120bb2a', component.options)
    } else {
      api.reload('9120bb2a', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailBLFreightPop.vue?vue&type=template&id=9120bb2a", function () {
      api.rerender('9120bb2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailBLFreightPop.vue"
export default component.exports